const DefaultImgAlt = 'Main listing image';

export const getDefaultImgAlt = (): string => {
  return DefaultImgAlt;
};
